import React from 'react';
import HeroArea from '../components/project/ProjectHero';
import NextProjectButton from '../components/project/NextProjectButton';
import ProjectIntro from '../components/project/ProjectIntro';
import { IProjectList } from '../components/project/ProjectList';
import ProjectShowCaseDesktop, { IDesktopScreen } from '../components/project/ProjectShowcaseDesktop';

import hero from '../assets/images/cover-image_newmotion.jpg'
import lazy from '../assets/compressed-images/cover-image_newmotion.png'
import ProjectShowCaseMobile, { IScreenMobile } from '../components/project/ProjectShowcaseMobile';

import ChargeAppCpDetail from '../assets/images/nm/chargeApp/chareApp_cp-details.png';
import ChargeAppMapSelect from "../assets/images/nm/chargeApp/chareApp_map-selected.png";
import ChargeAppMap from "../assets/images/nm/chargeApp/chareApp_map.png";
import ChargeAppProxi from "../assets/images/nm/chargeApp/chareApp_proximity.png";
import ChargeAppSearch from "../assets/images/nm/chargeApp/chareApp_search.png";
import ChargeAppMenu from "../assets/images/nm/chargeApp/chareApp_menu.gif";

import InstallAppWelcome from "../assets/images/nm/installApp/installAppWelcome.gif";
import InstallAppConfigSuccess from "../assets/images/nm/installApp/installAppConfigSuccess.gif";
import InstallAppStartConfig from "../assets/images/nm/installApp/installAppStartConfig.gif";
import InstallAppFuseBox from "../assets/images/nm/installApp/configFuseBox.gif";
import InstallAppSelectInstall from "../assets/images/nm/installApp/installApp_selectInstall.png";
import InstallAppCheckSetting from "../assets/images/nm/installApp/installApp_checkConfigSetting.png";

import DesktopCpConfig from "../assets/images/nm/desktopSupport/desktopSupport_cpConfig.gif"
import DesktopMechanicDetails from "../assets/images/nm/desktopSupport/desktopSupport_mechanicDetails.png"
import DesktopOverview from "../assets/images/nm/desktopSupport/desktopSupport_overview.png"
import IShowCaseTypes from '../models/IShowCaseTypes';
import ProjectShowCaseText, { IText } from '../components/project/ProjectShowCaseText';

import AnimCardShine from "../assets/images/nm/anim/cardShine.gif";
import AnimBeta from "../assets/images/nm/anim/Installers-Beta.gif";
import AnimRestart from "../assets/images/nm/anim/restart.gif";

import { IImage } from '../models/IScreen';
import ProjectShowCaseRaster from '../components/project/ProjectShowcaseRaster';
import CloseProject from 'components/shared/CloseProject';

interface IScreenRaster {
    type: IShowCaseTypes.raster;
    items: IImage[]
}

function Newmotion() {
    const chargeAppMap: IScreenMobile = { type: IShowCaseTypes.mobile, src: ChargeAppMap, alt: 'NewMotion consumer app charge point overview', fileName: 'chareApp_map' };
    const chargeAppMapSelect: IScreenMobile = { type: IShowCaseTypes.mobile, src: ChargeAppMapSelect, alt: 'NewMotion consumer app selected charge point on map', fileName: 'chareApp_map-selected' };
    const chargeAppCpDetail: IScreenMobile = { type: IShowCaseTypes.mobile, src: require('../assets/images/nm/chargeApp/chareApp_cp-details.png'), alt: 'NewMotion consumer app charge detail', fileName: 'chareApp_cp-details' };
    const chargeAppProxi: IScreenMobile = { type: IShowCaseTypes.mobile, src: ChargeAppProxi, alt: 'NewMotion consumer app list of nearby charge points', fileName: '' };
    const chargeAppSearch: IScreenMobile = { type: IShowCaseTypes.mobile, src: ChargeAppSearch, alt: 'NewMotion consumer app searching for location', fileName: '' };

    const installAppWelcome: IScreenMobile = { type: IShowCaseTypes.mobile, src: InstallAppWelcome, alt: 'Mechanic app welcome screen', fileName: '' };
    const installAppSelectInstall: IScreenMobile = { type: IShowCaseTypes.mobile, src: InstallAppSelectInstall, alt: 'Mechanic app select type of installation', fileName: '' };
    const installAppStartConfig: IScreenMobile = { type: IShowCaseTypes.mobile, src: InstallAppStartConfig, alt: 'Mechanic app start configuration', fileName: '' };
    const installAppFuseBox: IScreenMobile = { type: IShowCaseTypes.mobile, src: InstallAppFuseBox, alt: 'Mechanic app add amperage for fusebox', fileName: '' };
    const installAppCheckSetting: IScreenMobile = { type: IShowCaseTypes.mobile, src: InstallAppCheckSetting, alt: 'Mechanic app check selected settings', fileName: '' };
    const installAppConfigSuccess: IScreenMobile = { type: IShowCaseTypes.mobile, src: InstallAppConfigSuccess, alt: 'Mechanic app successful configuration screen', fileName: '' };

    const desktopCpConfig: IDesktopScreen = { type: IShowCaseTypes.desktop, fakeUrl: "newmotion.com/support", src: DesktopCpConfig, alt: 'Installation support tool detail page of a charge point', fileName: '' };
    const desktopMechanicDetails: IDesktopScreen = { type: IShowCaseTypes.desktop, fakeUrl: "newmotion.com/mechanic", src: DesktopMechanicDetails, alt: 'Installation support tool detail page of a mechanic', fileName: '' };
    const desktopOverview: IDesktopScreen = { type: IShowCaseTypes.desktop, fakeUrl: "newmotion.com/overview", src: DesktopOverview, alt: 'Installation support tool overview of all configurations', fileName: '' };


    const animGroup: IImage = { alt: 'animation for online charge point', src: require('../assets/images/nm/anim/powersharing.gif'), fileName: '' };
    const animCardShine: IImage = { alt: 'animation for online charge point', src: AnimCardShine, fileName: '' };
    const animError: IImage = { alt: 'animation for online charge point', src: require("../assets/images/nm/anim/error.gif"), fileName: '' };
    const animBeta: IImage = { alt: 'animation for online charge point', src: AnimBeta, fileName: '' };
    const animRestart: IImage = { alt: 'animation for online charge point', src: AnimRestart, fileName: '' };

    const animOffline2: IImage = { alt: 'animation for online charge point', src: require('../assets/images/nm/anim/offline.gif'), fileName: 'offline' };


    const anim1: IScreenRaster = {
        type: IShowCaseTypes.raster,
        items: [animCardShine, animGroup, animError, animBeta, animRestart, animOffline2]
    }

    const title: string = "NewMotion";
    const summary: string = "A company that offers a complete solution for charging electric vehicles. Ranging from drivers, mechanics to companies";

    const projectLists: Array<IProjectList> = [{
        nameOfList: 'Category',
        items: ["Design", "Mobile", "Animation", "UX Design", "User testing"]
    },
    {
        nameOfList: 'Technology',
        items: ["Invision", "Sketch", "Lottie Library", "After Effects"]
    }];

    const chargeAppMenu: IScreenMobile = {
        type: IShowCaseTypes.mobile, src: ChargeAppMenu, alt: 'Consumer app menu'
    };

    const textDriver: IText = {
        type: IShowCaseTypes.text,
        text: {
            title: "Drivers Charge App",
            paragraphs: ["Find a charge points, start charge sessions and manage your charge card. Redesigned for better UX and readability by simplifying and emphasizing the task at hand."]
        }
    }

    const textInstall: IText = {
        type: IShowCaseTypes.text,
        text: {
            title: "Installers App",
            paragraphs: ["Developed for mechanics to improve workflow. Made with ease in mind for the user and making growth more scalable for the company."]
        }
    }
    const textInstallSupport: IText = {
        type: IShowCaseTypes.text,
        text: {
            title: "Installation Support",
            paragraphs: ["A superuser platform created for desk support to manage account access to the installers app, configuration of charge points and to monitor the progress."]
        }
    }
    const textAnimation: IText = {
        type: IShowCaseTypes.text,
        text: {
            paragraphs: ["Here are some other animations originally made for SVG. Ideal for responsive design, low data usage and to alter during runtime for e.g. white labeling"]
        }
    }

    const content: Array<Array<IScreenMobile | IText | IDesktopScreen>> = [
        [textDriver],
        [chargeAppMenu],
        [chargeAppMap, chargeAppMapSelect, chargeAppCpDetail],
        [chargeAppProxi, chargeAppSearch],
        [textInstall],
        [installAppWelcome],
        [installAppStartConfig, installAppSelectInstall, installAppFuseBox],
        [installAppCheckSetting, installAppConfigSuccess],
        [textInstallSupport],
        [desktopOverview],
        [desktopCpConfig],
        [desktopMechanicDetails],
        [textAnimation]
    ];

    const showCase = content.map((item: IScreenMobile[] | IDesktopScreen | IText | any, index: number) => {
        switch (item[0].type) {
            case IShowCaseTypes.mobile:
                return <ProjectShowCaseMobile key={index} screens={item} />;
            case IShowCaseTypes.desktop:
                return <ProjectShowCaseDesktop key={index} screen={item[0]} />;
            case IShowCaseTypes.text:
                return <ProjectShowCaseText key={index} text={item[0].text} />
        }
    });



    return (
        <>
            <CloseProject />
            <HeroArea hero={hero} placeholder={lazy} />
            <ProjectIntro summary={summary} projectLists={projectLists} title={title} />
            {showCase}
            <ProjectShowCaseRaster items={anim1.items} bgColor={'#000000'} />
            <NextProjectButton />

        </>
    );
};

export default Newmotion